<template>
    <v-card outlined>
        <v-card-text>
            <v-row wrap ro align="center">
                <v-col cols="12">
                    <nav v-if="showPlantillas" class="select-tabs">
                        <button
                            type="button"
                            class="select-tabs__item"
                            :class="{ 'select-tabs__item--active': modo === 'buscar' }"
                            @click="modo = 'buscar'"
                        >Buscar producto</button>
                        <button
                            type="button"
                            class="select-tabs__item"
                            :class="{ 'select-tabs__item--active': modo === 'plantillas' }"
                            @click="irAPlantillas"
                        >Plantillas</button>
                    </nav>

                    <div v-if="showPlantillas && modo === 'plantillas'">
                        <v-row dense align="center">
                            <v-col cols="12" sm="8">
                                <v-select
                                    dense
                                    v-model="plantillaId"
                                    :items="plantillas"
                                    :loading="loadingPlantillas || agregandoPlantilla"
                                    item-text="name"
                                    item-value="id"
                                    label="Plantillas de venta"
                                    placeholder="Elegí una plantilla y sus productos se agregan solos"
                                    no-data-text="No hay plantillas disponibles"
                                    hide-details="auto"
                                    @change="aplicarPlantilla"
                                >
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <v-list-item-title>{{ item.name }}</v-list-item-title>
                                            <v-list-item-subtitle>{{ item.items.length }} producto(s)</v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <span>{{ item.name }} · {{ item.items.length }} producto(s)</span>
                                    </template>
                                </v-select>
                                <p class="caption grey--text mt-2 mb-0">
                                    Al elegirla, sus productos entran como líneas independientes con la cantidad de la
                                    plantilla. Después podés ajustar unidades, comisión o descuento de cada línea.
                                </p>
                            </v-col>
                        </v-row>
                        <v-row dense v-if="!loadingPlantillas && plantillas.length === 0">
                            <v-col cols="12">
                                <p class="caption grey--text mb-0">
                                    No hay plantillas cargadas. Se administran en facturación, en Productos → Productos plantilla.
                                </p>
                            </v-col>
                        </v-row>
                    </div>

                    <form v-if="modo !== 'plantillas'" autocomplete="nope" @submit.prevent="postData">
                        <v-container grid-list-md fluid>
                            <v-row dense align="center">
                                <v-col cols="12" sm="12">
                                    <v-autocomplete
                                        dense
                                        v-model="servicio"
                                        :items="searchResults"
                                        :loading="isSearching"
                                        :search-input.sync="productSearch"
                                        label="Buscar producto"
                                        placeholder="Ej: laptop dell"
                                        data-vv-as="marca"
                                        :error-messages="errors.collect('servicio')"
                                        data-vv-name="servicio"
                                        required
                                        item-text="rename"
                                        item-value="id"
                                        return-object
                                        no-filter
                                        hide-no-data
                                        @change="onProductSelected"
                                    >
                                        <template v-slot:item="data">
                                            <v-chip small color="secondaryTheme" class="caption px-2" dark
                                                >{{ data.item.marca ? data.item.marca : data.item.category }}-{{ data.item.internal_id }}</v-chip
                                            >
                                            <v-chip v-if="data.item.idCodigo" small color="green" class="caption px-2" dark>{{ data.item.idCodigo }}</v-chip>
                                            <span class="caption"
                                                >{{ data.item.rename }} |
                                                {{ isformatNumber(data.item, 'price') }}
                                            </span>
                                        </template>
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="2">
                                    <v-text-field dense v-model="servicio.unidades" label="Unidades" @keypress="isNumber" />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field v-if="options" dense v-model="servicio.comision" label="Comisión POS (+)" />
                                </v-col>
                                <v-col v-if="options == true" cols="12" sm="3">
                                    <v-text-field dense v-model="servicio.descuentos" label="Descuentos (-)" />
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field dense v-model="itemTotalProduct.subTotal" filled rounded label="Sub total" readonly />
                                </v-col>
                                <v-col cols="12" sm="12" class="text-center">
                                    <v-row>
                                        <v-col v-if="itemTotalProduct.subTotal != 0" cols="12" sm="3"
                                            ><v-btn block color="secondaryTheme" dark type="submit">agregar</v-btn></v-col
                                        >
                                        <v-col cols="12" sm="4" v-if="options"
                                            ><v-btn :disabled="datos.atributos.wtspProductos" block color="green" @click="sendSmsWhatsapp" dark>
                                                <v-icon left>mdi-whatsapp</v-icon>
                                                Enviar productos
                                            </v-btn></v-col
                                        >
                                        <v-col cols="12" sm="3" v-if="options"
                                            ><v-btn :disabled="datos.atributos.wtspService" block color="green" @click="sendServiceWhataspp" dark>
                                                <v-icon left>mdi-whatsapp</v-icon>
                                                Enviar servicios
                                            </v-btn></v-col
                                        >
                                    </v-row>
                                </v-col>
                                <v-spacer></v-spacer>
                            </v-row>
                        </v-container>
                    </form>
                </v-col>
                <v-col cols="12" class="grey lighten-5">
                    <v-data-table multi-sort :headers="headers" :items="_productos" class="elevation-1" :items-per-page="20" item-key="_rowIndex">
                        <template v-slot:[`item.action`]="{ item }">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" color="secondaryTheme" @click="openLineEdit(item)">mdi-pencil</v-icon>
                                </template>
                                <span>EDITAR MONTOS</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on" color="green" @click="upItem(item)">mdi-swap-vertical</v-icon>
                                </template>
                                <span>SUBIR</span>
                            </v-tooltip>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon color="primary" v-bind="attrs" v-on="on" small @click="deleteItem(item)">mdi-delete</v-icon>
                                </template>
                                <span>ELIMINAR</span>
                            </v-tooltip>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-card-text>
        <v-dialog v-model="lineEdit.open" max-width="480" persistent>
            <v-card>
                <v-card-title class="grey lighten-4">Editar montos de la línea</v-card-title>
                <v-card-text class="pt-4">
                    <p class="body-2 mb-3">{{ lineEdit.description }}</p>
                    <v-row dense>
                        <v-col cols="12">
                            <v-text-field dense readonly :value="lineEdit.price" label="Precio unitario (catálogo)" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field dense v-model="lineEdit.unidades" label="Unidades" @keypress="isNumber" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field dense v-model="lineEdit.comision" label="Comisión POS (+)" @keypress="isNumber" />
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field dense v-model="lineEdit.descuentos" label="Descuentos (-)" :disabled="!options" @keypress="isNumber" />
                        </v-col>
                        <v-col cols="12">
                            <v-text-field dense readonly :value="lineEditSubTotal" label="Sub total" />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="closeLineEdit">Cancelar</v-btn>
                    <v-btn color="secondaryTheme" dark @click="saveLineEdit">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { mapState } from 'vuex'
import { mixins } from '@/mixins/mixin.js'
import DefaultForm from '@/utils/defaultForm'
import { formatNumber } from '@/utils/genericUtils'
import { sleep } from '@/utils/genericUtils'
import { calcLineSubTotal, updateLineInList } from '@/utils/lineTotals'
import { appendPlantillaLines } from '@/utils/plantillaLines'
import { filtrarItemsSeleccionables, descripcionItem, esItemSeleccionable } from '@/utils/itemsSeleccionables'
import { debounce } from 'lodash'
export default {
    filters: {},
    props: {
        lista: { default: null },
        service: { default: null },
        notOptions: { default: null },
        // Boolean: el atributo sin valor (show-plantillas) llega como true.
        // Con la forma de array, Vue 2 lo entrega como cadena vacia (falsa) y
        // las pestañas nunca se renderizaban.
        showPlantillas: { type: Boolean, default: false },
    },
    mixins: [mixins],
    $_veeValidate: {
        validator: 'new'
    },
    data() {
        return {
            msgWhatsapp: '',
            descriptionLimit: 60,
            ProductosFilter: [],
            isLoading: false,
            model: null,
            servicio: DefaultForm.formSelectServicio(),
            search: null,
            productSearch: '',
            searchResults: [],
            isSearching: false,
            modo: 'buscar',
            plantillas: [],
            plantillaId: null,
            plantillasLoaded: false,
            loadingPlantillas: false,
            agregandoPlantilla: false,
            lineEdit: { open: false, index: null, description: '', price: 0, unidades: 1, comision: 0, descuentos: 0 },
            _debouncedSearch: null,
            headers: [
                { text: 'Actions', value: 'action', sortable: false },
                { text: 'Descripción', value: 'description' },
                { text: 'Tipo', value: 'unit_type_id' },
                { text: 'Codigo', value: 'internal_id' },
                { text: 'Marca', value: 'marca' },
                { text: 'Unidades', value: 'unidades', width: 110 },
                { text: 'Moneda', value: 'tipoMoneda' },
                { text: 'Precio', value: '_subTotal' },
                { text: 'Comision', value: 'comision', width: 110 },
                { text: 'Descuento', value: 'descuentos', width: 120 },
                { text: 'SubTotal', value: 'subTotal' }
            ]
        }
    },
    watch: {
        /**
         * Lógica inmediata (limpiar UI) + debounce solo para la API.
         * CRÍTICO: NO limpiar searchResults después de seleccionar un producto.
         * Vuetify necesita la lista de items para validar la selección internamente.
         */
        productSearch(val) {
            // Input vacío (blur o clear)
            if (!val) {
                if (this.servicio && this.servicio.id) return
                this.servicio = DefaultForm.formSelectServicio()
                this.searchResults = []
                return
            }

            // Mínimo 4 caracteres
            if (val.trim().length < 4) return

            // Si hay producto seleccionado y el texto coincide con su display, no buscar
            // (Vuetify sincroniza search-input con item-text al seleccionar)
            if (this.servicio && this.servicio.id) {
                const selectedText = this.servicio.rename || this.servicio.name
                if (val === selectedText) return
                // El usuario tecleó algo distinto: limpiar selección
                // pero NO limpiar searchResults (Vuetify los necesita)
                this.servicio = DefaultForm.formSelectServicio()
            }

            this._debouncedSearch(val)
        },
    },
    computed: {
        ...mapState('utilities', ['tipoDocumento', 'tipoComprobante', 'tipoBancoDestino']),
        options() {
            return !this.notOptions
        },
        idTipoMoneda() {
            return this.servicio.idTipoMoneda || 1
        },
        ...mapState('ventas', ['datos', 'modalReserva', 'productos']),
        ...mapState('category', ['genericUtils']),
        ...mapState('users', ['user', 'listaUser']),
        idProducto() {
            return this.servicio.id
        },
        _selectItem() {
            return this.servicio
        },
        fields() {
            if (!this.model) return []
            return Object.keys(this.model).map((key) => {
                return {
                    key,
                    value: this.model[key] || 'n/a'
                }
            })
        },
        _productos() {
            const _listaPro = []
            try {
                if (this.productos && this.productos.length > 0) {
                    this.productos.forEach((x, index) => {
                        _listaPro.push({
                            ...x,
                            _rowIndex: index,
                            tipoMoneda: x.idTipoMoneda === 1 ? 'S/' : '$',
                            internal_id: x.internal_id || 'No registrado',
                            _subTotal: x.price || x.price.toFixed(2)
                        })
                    })
                }
            } catch (error) {
                //console.log('err', error)
            }
            return _listaPro
        },
        lineEditSubTotal() {
            return calcLineSubTotal({
                price: this.lineEdit.price,
                comision: this.lineEdit.comision,
                unidades: this.lineEdit.unidades,
                descuentos: this.lineEdit.descuentos
            }).subTotal
        },
        itemTotalProduct() {
            const totals = calcLineSubTotal({
                price: this.servicio.price,
                comision: this.servicio.comision,
                unidades: this.servicio.unidades,
                descuentos: this.servicio.descuentos
            })
            return {
                price: totals.price + totals.comision,
                subTotal: totals.subTotal
            }
        }
    },
    created() {
        this._debouncedSearch = debounce((val) => {
            this.performProductSearch(val)
        }, 500)
    },
    beforeDestroy() {
        if (this._debouncedSearch) this._debouncedSearch.cancel()
    },
    methods: {
        async performProductSearch(searchText) {
            this.isSearching = true
            try {
                const results = await this.$store.dispatch('productos/searchProductos', {
                    text: searchText,
                    idSede: this.user.idSede
                })
                // Si el usuario ya escribió algo distinto, descartar esta respuesta
                if (this.productSearch !== searchText) return
                // Un ítem sin descripción no se ofrece (ver utils/itemsSeleccionables.js).
                const items = filtrarItemsSeleccionables(results)
                this.searchResults = items.map(p => ({
                    ...p,
                    rename: `${descripcionItem(p)} -|- ${p.internal_id}`,
                    price: p.sale_unit_price,
                    comision: 0,
                    descuentos: 0,
                    unidades: 1
                }))
            } catch (error) {
                if (this.productSearch === searchText) {
                    this.searchResults = []
                }
            } finally {
                this.isSearching = false
            }
        },

        onProductSelected(product) {
            if (!product) return
            // CRÍTICO: Modificar el objeto existente en lugar de reemplazarlo.
            // Vuetify's autocomplete trackea la referencia del v-model.
            // Si creamos un nuevo objeto, Vuetify pierde la selección.
            Object.assign(this.servicio, {
                id: product.id,
                name: product.name,
                description: descripcionItem(product),
                internal_id: product.internal_id,
                sale_unit_price: product.sale_unit_price,
                price: product.sale_unit_price,
                comision: 0,
                descuentos: 0,
                unidades: 1,
                idTipoMoneda: product.idTipoMoneda || (product.currency_type_id === 'USD' ? 2 : 1),
                rename: `${descripcionItem(product)} -|- ${product.internal_id}`,
                supplier_name: product.supplier_name || null,
                supplier_id: product.supplier_id || null
            })
        },

        async sendServiceWhataspp() {
            const { id, celularContacto, telefono, phoneClient } = this.datos
            const phone = celularContacto || telefono || phoneClient

            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número de teléfono no disponible',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            let listProducts = ''
            for (const item of this.productos) {
                listProducts += `\n •*${item.description}* ; Cantidades ${item.unidades}`
            }

            const colaborador = this.listaUser.find((x) => x.id == this.datos.idColaborador)?.nombres ?? this.user.nombres + ' ' + this.user.apellidos

            const message = `📅 Hola,
Le confirmamos que su servicio ha sido programado para el día ${this.datos.chec_in}, con atención a cargo del técnico "${colaborador}".

📍 Dirección: ${this.datos.direccionEnvio}
📌 Ubicación: ${this.datos.enlaceGoogleMaps}
🕓 Rango de atención: de 9 am a 5 pm

Si tiene alguna observación o desea reprogramar su servicio, le pedimos avisarnos con un día de anticipación.

Para más detalles sobre las condiciones del servicio puede consultar 👉 https://cubaspa.com.pe/condiciones-del-servicio/

¡Gracias por confiar en CUBASPA y KUNTESPA! 💧`

            const original = String(phone || '')
            const raw = original.replace(/\D+/g, '')
            const normalized = raw.startsWith('51') ? raw : `51${raw}`
            if (!/^51\d{7,12}$/.test(normalized)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                await sleep(2000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }
            const whatsappUrl = `https://wa.me/${normalized}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl, '_blank')

            await this.$store.dispatch('ventas/patchVenta', {
                ...this.datos,
                atributos: { ...this.datos.atributos, wtspService: true }
            })

            this.$store.commit('mainUI/OPEN_MODAL', {
                state: true,
                text: 'Mensaje enviado correctamente',
                color: 'green'
            })
            await sleep(3000)
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },

        async sendSmsWhatsapp() {
            const { celularContacto, telefono, phoneClient } = this.datos
            const phone = celularContacto || telefono || phoneClient

            if (!phone) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número de teléfono no disponible',
                    color: 'red'
                })
                await sleep(3000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }

            let listProducts = ''
            for (const iterator of this.productos) {
                let ProductFacturacion = await this.$store.dispatch('ventas/obtenerProducto', {
                    id: iterator.id,
                    idSede: this.user.idSede
                })
                const linkProduct = ProductFacturacion?.data?.attributes
                    ? JSON.parse(ProductFacturacion.data.attributes).find((x) => x.attribute_type_id == '8000') || null
                    : null
                listProducts += `\n• *${iterator.description}* ; Cantidades ${iterator.unidades}${linkProduct ? `\nLink : ${linkProduct.value}` : ''}`
            }

            const colaborador = this.listaUser.find((x) => x.id == this.datos.idColaborador)?.nombres ?? this.user.nombres + ' ' + this.user.apellidos

            const message = `¡Ya estamos preparando tu compra!

hemos recibido tu orden de compra que realizaste con la ejecutiva ${colaborador}.
Este es tu número de orden ${this.datos.id}.
Revisa el estado y el detalle de tu orden:
Lista de productos:
${listProducts}

-> Estamos procediendo a preparar tu pedido.
-> Si tuvieras alguna observación por favor comunicarlo.`

            const original2 = String(phone || '')
            const raw2 = original2.replace(/\D+/g, '')
            const normalized2 = raw2.startsWith('51') ? raw2 : `51${raw2}`
            if (!/^51\d{7,12}$/.test(normalized2)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    text: 'ERROR - Número inválido para WhatsApp',
                    color: 'red'
                })
                await sleep(2000)
                this.$store.commit('mainUI/OPEN_MODAL', { state: false })
                return
            }
            const whatsappUrl2 = `https://wa.me/${normalized2}?text=${encodeURIComponent(message)}`
            window.open(whatsappUrl2, '_blank')

            await this.$store.dispatch('ventas/patchVenta', {
                ...this.datos,
                atributos: { ...this.datos.atributos, wtspProductos: true }
            })

            this.$store.commit('mainUI/OPEN_MODAL', {
                state: true,
                text: 'Mensaje enviado correctamente',
                color: 'green'
            })
            await sleep(3000)
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },

        isformatNumber(item, name) {
            const value = item[name]
            return formatNumber(value, item.idTipoMoneda)
        },
        _parseFloat(val) {
            return parseFloat(val) || 0
        },

        deleteItem(item) {
            const lista = this.productos.filter((line, index) => index !== item._rowIndex)
            this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
        },
        openLineEdit(item) {
            this.lineEdit = {
                open: true,
                index: item._rowIndex,
                description: item.description,
                price: item.price,
                unidades: item.unidades ?? 1,
                comision: item.comision ?? 0,
                descuentos: item.descuentos ?? 0
            }
        },
        closeLineEdit() {
            this.lineEdit = { open: false, index: null, description: '', price: 0, unidades: 1, comision: 0, descuentos: 0 }
        },
        /**
         * Guarda solo la fila abierta, recalculando su subTotal con la misma
         * formula del formulario de alta. El precio de catalogo no se toca.
         */
        saveLineEdit() {
            const lista = updateLineInList(this.productos, this.lineEdit.index, {
                price: this.lineEdit.price,
                comision: this.lineEdit.comision,
                unidades: this.lineEdit.unidades,
                descuentos: this.lineEdit.descuentos
            })
            if (lista) this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
            this.closeLineEdit()
        },
        upItem(newItem) {
            const position = this.productos.findIndex((x) => x.timestamp == newItem.timestamp)
            const lista = Object.assign([], this.productos)
            if (position >= 1) {
                const oldItem = { ...lista[position - 1], timestamp: Date.now() }
                lista.splice(position, 1, oldItem)
                lista.splice(position - 1, 1, newItem)
                this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
            }
        },
        async irAPlantillas() {
            this.modo = 'plantillas'
            await this.cargarPlantillas()
        },

        /**
         * Carga las plantillas de venta de la sede la primera vez que se abre la
         * pestaña. Un error se avisa: mostrar "sin plantillas" haría pensar que
         * no hay ninguna cargada cuando en realidad falló la consulta.
         */
        async cargarPlantillas() {
            if (this.plantillasLoaded || this.loadingPlantillas) return

            this.loadingPlantillas = true
            try {
                this.plantillas = await this.$store.dispatch('productos/getPlantillas', {
                    idSede: this.user.idSede
                })
                this.plantillasLoaded = true
            } catch (error) {
                await this.avisar(`No se pudieron cargar las plantillas: ${error.message || 'error de conexión'}`, 'red')
            } finally {
                this.loadingPlantillas = false
            }
        },

        async avisar(text, color = 'green', duration = 2500) {
            this.$store.commit('mainUI/OPEN_MODAL', { state: true, text, color })
            await sleep(duration)
            this.$store.commit('mainUI/OPEN_MODAL', { state: false })
        },

        /**
         * Agrega todos los productos de la plantilla como líneas independientes.
         * Las líneas ya cargadas no se tocan.
         */
        /**
         * Elegir una plantilla agrega sus productos en el acto: cada uno entra como
         * línea independiente con la cantidad de la plantilla y el precio del
         * catálogo. Luego vuelve a la vista de búsqueda, que es donde está el
         * listado de líneas, y confirma cuántos productos entraron.
         */
        async aplicarPlantilla(plantillaId) {
            if (plantillaId === null || plantillaId === undefined || plantillaId === '') return

            const plantilla = this.plantillas.find(
                (item) => String(item.id) === String(plantillaId)
            )

            if (!plantilla) {
                this.plantillaId = null
                await this.avisar('No se encontró la plantilla elegida', 'red')
                return
            }

            this.agregandoPlantilla = true
            try {
                const antes = Array.isArray(this.productos) ? this.productos.length : 0
                const lista = appendPlantillaLines(this.productos, plantilla)

                if (lista.length === antes) {
                    this.plantillaId = null
                    await this.avisar('La plantilla no tiene productos para agregar', 'red')
                    return
                }

                this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
                this.plantillaId = null
                this.modo = 'buscar'
                await this.avisar(`Plantilla "${plantilla.name}": ${lista.length - antes} producto(s) agregados`)
            } finally {
                this.agregandoPlantilla = false
            }
        },

        postData() {
            if (!esItemSeleccionable(this.servicio)) {
                this.$store.commit('mainUI/OPEN_MODAL', {
                    state: true,
                    close: true,
                    text: 'El producto seleccionado no tiene descripción. Elegí otro o corregí el ítem en facturación: sin descripción, SUNAT rechaza el comprobante con el código 2026.'
                })
                return
            }
            this.$validator.validateAll().then(async (result) => {
                if (result) {
                    let lista = []
                    const listaServicios = []
                    const servicio = {
                        ...this.servicio,
                        priceOrigen: this.servicio.sale_unit_price,
                        idTipoMoneda: this.servicio.idTipoMoneda ? this.servicio.idTipoMoneda : 1,
                        price: this.servicio.price,
                        subTotal: this.itemTotalProduct.subTotal,
                        timestamp: Date.now()
                    }
                    const tipoCambio = servicio.idTipoMoneda === 1 ? 1 : null
                    this.$store.commit('ventas/UPDATE_DATOS', {
                        idTipoMoneda: servicio.idTipoMoneda,
                        tipoCambio
                    })
                    listaServicios.push(servicio)
                    lista = this.productos.concat(listaServicios)
                    this.$store.commit('ventas/UPDATE_PRODUCTOS', lista)
                    this.servicio = DefaultForm.formSelectServicio()
                    this.searchResults = []
                    this.productSearch = ''
                }
            })
        }
    }
}
</script>
<style scoped>
.select-tabs {
    display: flex;
    align-items: center;
    margin: 0 0 18px 2px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.select-tabs__item {
    position: relative;
    padding: 6px 2px 8px;
    margin-right: 26px;
    border: 0;
    background: none;
    font-size: 0.8125rem;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #8a8a8a;
    cursor: pointer;
    transition: color 0.15s ease;
}

.select-tabs__item:hover {
    color: #333;
}

.select-tabs__item::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: -1px;
    height: 2px;
    background: currentColor;
    opacity: 0;
    transition: opacity 0.15s ease;
}

.select-tabs__item--active {
    color: #111;
    font-weight: 500;
}

.select-tabs__item--active::after {
    opacity: 1;
}
</style>
